import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { SlidingTutorial } from '../../../components/sliding-tutorial/sliding-tutorial'

function SlidingTutorialPanel(props) {
  return (
    <SlidingTutorial
      {...props}
      yOffset={30} // This value depends on onboarding header size and visibility
      zIndex={1002}
    />
  )
}

export const reactSlidingTutorial = createNgReactBridgeDirective(
  'reactSlidingTutorial',
  [],
  SlidingTutorialPanel,
  ['isVisible', 'tutorialKey', 'orgUuid', 'appId']
)
